import { useState, useEffect, useMemo } from 'react';
import { debounce } from 'lodash';

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  const debouncedSetScreenSize = useMemo(
    () => debounce((size) => setScreenSize(size), 250), // 250ms delay
    []
  );

  useEffect(() => {
    const handleResize = () => {
      debouncedSetScreenSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      debouncedSetScreenSize.cancel();
    };
  }, [debouncedSetScreenSize]);

  return screenSize;
};

export default useScreenSize;
